'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'face-thermometer';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e39a';
var svgPathData = 'M288 47.1C173.1 47.1 80 141.1 80 255.1C80 370.9 173.1 464 288 464C353.9 464 412.7 433.3 450.8 385.5C452.3 384.2 453.7 382.9 455.2 381.5L540 301.1C518.8 420.1 414 512 288 512C146.6 512 32 397.4 32 256C32 114.6 146.6 0 288 0C385 0 469.4 53.96 512.8 133.5C496.3 133.2 479.8 137.9 465.5 147.6C428.1 87.84 363.1 48 288 48L288 47.1zM545.9 251.5L415.1 376.1C413.1 380.2 411.7 384.1 408.3 387.3C398.5 396.3 383.3 395.6 374.4 385.9C359.2 369.5 333.2 352 296 352C258.8 352 232.8 369.5 217.6 385.9C208.7 395.6 193.5 396.3 183.7 387.3C173.1 378.3 173.4 363.1 182.4 353.4C204.3 329.5 242.3 303.1 296 303.1C312.2 303.1 327.1 306.3 340.4 310.3L476.1 179.4C496.6 160.6 527.6 160.1 546.8 180.1C566.6 199.1 566.2 232.2 545.9 251.5L545.9 251.5zM429.4 318.3L423.5 312.5C418.8 307.8 418.8 300.2 423.5 295.5C428.2 290.8 435.8 290.8 440.5 295.5L446.7 301.8L462.1 287.1L455.5 280.5C450.8 275.8 450.8 268.2 455.5 263.5C460.2 258.8 467.8 258.8 472.5 263.5L479.5 270.6L494.9 255.9L487.5 248.5C482.8 243.8 482.8 236.2 487.5 231.5C492.2 226.8 499.8 226.8 504.5 231.5L512.3 239.3L523.8 228.4C531.1 221.4 531.2 209.9 524.1 202.8C517.3 195.9 506.1 195.8 499.1 202.5L372.5 323.9C383.7 330.2 393.3 337.5 401.3 345L429.4 318.3zM176.4 207.1C176.4 190.3 190.7 175.1 208.4 175.1C226 175.1 240.4 190.3 240.4 207.1C240.4 225.7 226 239.1 208.4 239.1C190.7 239.1 176.4 225.7 176.4 207.1zM400.4 207.1C400.4 225.7 386 239.1 368.4 239.1C350.7 239.1 336.4 225.7 336.4 207.1C336.4 190.3 350.7 175.1 368.4 175.1C386 175.1 400.4 190.3 400.4 207.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceThermometer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;